// src/context/PermissionContext.js
import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const [permissions, setPermissions] = useState([]);
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = checking, false = unauthenticated, true = authenticated
  const [isLoading, setIsLoading] = useState(true);

  const checkAuth = () => {
    const token = localStorage.getItem("access_token");
    const expiryTime = localStorage.getItem("token_expiry");
    const currentTime = Date.now();
    return token && expiryTime && currentTime < parseInt(expiryTime, 10);
  };

  const refreshAuthStatus = async () => {
    setIsLoading(true);
    const authStatus = checkAuth();
    setIsAuthenticated(authStatus);

    if (!authStatus) {
      setPermissions([]);
      setIsLoading(false);
      return;
    }

    try {
      const response = await axios.get(
        "https://pevbackend.codovio.com/public/api/get-my-assigned-permissions",
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      if (response.data.success) {
        setPermissions(response.data.permissions);
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
        setPermissions([]);
        localStorage.removeItem("access_token");
        localStorage.removeItem("token_expiry");
        localStorage.removeItem("user");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
      setIsAuthenticated(false);
      setPermissions([]);
      localStorage.removeItem("access_token");
      localStorage.removeItem("token_expiry");
      localStorage.removeItem("user");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshAuthStatus();
  }, []); // Run once on mount

  const hasPermission = (permissionKey) => {
    return permissions.some((perm) => perm.permission_key === permissionKey);
  };



  return (
    <PermissionContext.Provider
      value={{
        permissions,
        hasPermission,
        isAuthenticated,
        isLoading,
        refreshAuthStatus,
      }}
    >
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermissions = () => useContext(PermissionContext);
